import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import {
  APP_TYPE_OPTIONS,
  COLOR_USER_TYPE_BAR,
  COLOR_VOC_TYPE,
  getOptionImage,
  getPlatFormImage,
  LIST_OPTION_BAR_LIST_OPEN_STATUS,
  LIST_OPTION_SOURCE_APP,
  LIST_VOC_TYPE_OPTION,
  USER_TYPE_BAR_OPTION,
} from "helpers/constans";
import CountUp from "react-countup";
import { formatDateStringToKorea, formatDateStringToUTC } from "helpers/format";
import CollapseFilter from "components/Common/CollapseFilter";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import moment from "moment";
import DatePickerCustom from "components/Common/DatePickerCustom";
import { getVOCList } from "store/voc-list/thunk";
import DropdownAsyncVOCReason from "components/Common/DropdownAsyncVOCReason";
import avatar1 from "../../../assets/images/users/ic_defaul_avatar2.png";
import CopyWrapper from "components/Common/CopyWrapper";
import { capitalizeFirstLetter, truncate } from "utils";
import ModalPreview from "components/Common/ModalPreview";
import DropdownOptionNew from "components/Common/DropdownOptionNew";
import CollapseContent from "components/Common/CollapseContent";


const TYPE_SELECT_DEFAULT: string = "created_at";

registerLocale("en", en);
registerLocale("ko", ko);

const VOCList = () => {
  const { t, i18n } = useTranslation();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    type: withDefault(NumberParam, null),
    voc_reason_id: withDefault(NumberParam, null),
    app_name: withDefault(StringParam, ""),
    start_date: withDefault(StringParam, ""),
    end_date: withDefault(StringParam, ""),
    sort_by: withDefault(StringParam, "created_at"),
    order_by: withDefault(StringParam, "DESC"),
  });

  const [dateSearch, setDateSearch] = useState<any[]>([
    query?.start_date
      ? moment(query?.start_date || "", "Y-MM-DD").toDate()
      : null,
    query?.end_date ? moment(query?.end_date || "", "Y-MM-DD").toDate() : null,
  ]);
  const [startDate, endDate] = dateSearch;

  const [appNameSearch, setAppNameSearch] = useState<any>(
    LIST_OPTION_SOURCE_APP?.find((item) => item?.value === query?.app_name)
      ?.value || ""
  );

  const [reasonSearch, setReasonSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });

  const [vocTypeSearch, setVOCTypeSearch] = useState<any>(
    LIST_VOC_TYPE_OPTION?.find(
      (item) => item?.value === query?.type
    )?.value || ""
  );

  const dispatch: any = useDispatch();
  const selectLayoutState = (state: any) => state.VOCList;
  const RewardsProperties = createSelector(selectLayoutState, (state) => ({
    vocList: state.vocList,
    isVOCListLoading: state.isVOCListLoading,
    isVOCListSuccess: state.isVOCListSuccess,
    error: state.error,
  }));

  // Inside your component
  const { vocList, isVOCListLoading } = useSelector(RewardsProperties);
  const [linkImage, setLinkImage] = useState<string>("");

  function loadTableData() {
    dispatch(getVOCList(query));
  }

  const searchData = () => {
    setQuery({
      ...query,
      type: vocTypeSearch || '',
      voc_reason_id: reasonSearch?.value || '',
      app_name: appNameSearch?.value || '',
      start_date: startDate
        ? moment(new Date(startDate)).format("Y-MM-DD")
        : "",
      end_date: endDate
        ? moment(new Date(endDate)).endOf("day").format("Y-MM-DD")
        : "",
      sort_by: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        type: null,
        voc_reason_id: null,
        app_name: "",
        start_date: "",
        end_date: "",
        sort_by: TYPE_SELECT_DEFAULT,
        time_request: +new Date(),
      },
      "push"
    );
    setReasonSearch({
      label: t("All Filter"),
      value: "all",
    });
    setVOCTypeSearch((_prev: any) => "");
    setAppNameSearch((_prev: any) => "");
    setDateSearch([null, null]);
  };

  const onCloseImageClick = () => {
    setLinkImage((_prev) => "");
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 70,
        Cell: ({ ...props }) => {
          return (
            <div style={{ minWidth: "60px" }}>
              {vocList?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },
      {
        Header: t("App"),
        accessor: "app_name",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const item = cell?.value;
          let imgAppName = getOptionImage(item);

          return (
            item && (
              <div className="d-flex align-items-center whitespace-nowrap">
                {imgAppName ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgAppName ? (
                      <img
                        src={imgAppName}
                        width={20}
                        height={20}
                        alt="platform"
                      />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    APP_TYPE_OPTIONS?.find(
                      (item: any) => item?.value === cell?.value
                    )?.label || ""
                  )}
                </div>
              </div>
            )
          );
        },
      },
      {
        Header: t('VOC Type'),
        accessor: "reason",
        thClass: "text-center whitespace-nowrap",
        thWidth: 150,
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const typeId = cell?.value?.type;

          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_VOC_TYPE[typeId] || "secondary"
                  }`}
              >
                {t(
                  LIST_VOC_TYPE_OPTION?.find(
                    (item: any) => item?.value === typeId
                  )?.label || "-"
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t('User Type'),
        accessor: "user_type",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        Cell: (cell: any) => {
          const userType = cell?.row?.original?.user?.type;

          return (
            <div className="text-center" style={{ minWidth: 100 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_USER_TYPE_BAR[userType] || "secondary"
                  }`}
              >
                {t(
                  USER_TYPE_BAR_OPTION?.find(
                    (item: any) => item?.value === userType
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },
      {
        Header: t("Reason"),
        accessor: "ReasonName",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 220,
        Cell: (cell: any) => {
          const reason = cell?.row?.original?.reason;
          const name = i18n?.language === 'en' ? reason?.reason_en : reason?.reason_kr;

          return name ? (
            <div style={{minWidth: '200px'}}>
              <CopyWrapper contentCopy={name}>
                {truncate(name, 70)}
              </CopyWrapper>
            </div>
          ) : "-";
        },
      },
      {
        Header: t("Detail Reason"),
        accessor: "content",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const name = cell?.value;

          return name ? (
            <CopyWrapper contentCopy={name} style={{ minWidth: "100px" }}>
              <CollapseContent
                style={{ maxWidth: "120px" }}
                dataOriginal={name}
                isRank={false}
                isInlineBlock={true}
                isShowModal={true}
                numberCharactor={60}
                titleModal={t("Content")}
              />
            </CopyWrapper>
          ) : '-';
        },
      },
      {
        Header: t("Photo"),
        accessor: "profile_image_url",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 80,
        Cell: (cell: any) => {
          const userPhoto = cell?.row?.original?.user?.bg_image_url;

          return (
            <div className="w-100 text-center " style={{ minWidth: "60px" }}>
              <div
                style={{ width: "45px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage(userPhoto)}
              >
                <img
                  src={userPhoto ?? avatar1}
                  className="rounded-circle avatar-sm"
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = avatar1;
                  }}
                />
              </div>
            </div>
          )
        },
      },
      {
        Header: t("Nickname"),
        accessor: "nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const nickname = cell?.row?.original?.user?.nickname;

          return (
            nickname ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={nickname}>
                  {`${nickname}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },

      {
        Header: t("Email"),
        accessor: "email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const email = cell?.row?.original?.user?.email;
          return (
            email ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={email}>
                  {`${email}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },

      {
        Header: t("Platform"),
        accessor: "platform",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const item = cell?.row?.original?.user;

          let platform = item?.plaform;
          let imgPlatform = getPlatFormImage(platform);
          if (platform === "guest") {
            platform = "-";
          } else if (platform === "default") {
            platform = "Email";
          }

          return (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && platform !== "-" && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="platform"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(capitalizeFirstLetter(platform))}
                </div>
              </div>
            </div>
          );
        },
      },
      {
        Header: t("UUID"),
        accessor: "uuid_2",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const udid_2 = cell?.row?.original?.user?.uuid_2;

          return udid_2 ? (
            <div className="cursor-pointer" style={{ minWidth: "100px" }}>
              <CopyWrapper contentCopy={udid_2}>
                {`${udid_2}`}
              </CopyWrapper>
            </div>
          ) : (
            "-"
          );
        },
      },
      {
        Header: t("Created at"),
        accessor: "created_at",
        filterable: true,
        sortable: false,
        thWidth: 120,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, vocList?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  useEffect(() => {
    document.title = `${t("VOC Management")} - ${t('Home')} | Baive`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("VOC Management")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-5 con-sm-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t('Total')}:</span>
                          <CountUp
                            start={0}
                            end={vocList?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={t("App")} isShow={true}>
                          <DropdownOptionNew
                            name="app_name"
                            dataList={APP_TYPE_OPTIONS || []}
                            placeholder={`${t("Select App Name")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={appNameSearch}
                            onChangeSelect={(e: any) => setAppNameSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            lstImage={true}
                            hideSelectedOptions={false}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-2 mt-3"
                      >
                        <LabelWrapper label={t("VOC Type")} isShow={true}>
                          <DropdownStatusNew
                            name="status"
                            dataList={LIST_VOC_TYPE_OPTION || []}
                            placeholder={`${t("Select VOC type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={vocTypeSearch}
                            onChangeSelect={(e: any) =>
                              setVOCTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_VOC_TYPE}
                          />
                        </LabelWrapper>
                      </Col>


                      <Col
                        sm={12}
                        md={6}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-2 mt-3"
                      >
                        <LabelWrapper label={t("Reason")} isShow={true}>
                          <DropdownAsyncVOCReason
                            name="voc-reason"
                            onChangeSelect={(event: any) => {
                              setReasonSearch(event);
                            }}
                            isMulti={false}
                            placeholder={`${t("Select reason")}...`}
                            isShowIconCheck={false}
                            isAllOption={true}
                            listCheckedReason={reasonSearch}
                            keywordSearch={vocTypeSearch}
                            isClearable={false}
                            key={`${vocTypeSearch}-${i18n?.language}`}
                          />
                        </LabelWrapper>
                      </Col>
                      
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-4 mt-md-2 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={12}
                        xl={12}
                        xxl={12}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3 mt-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={vocList?.items?.length ? vocList?.items : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={vocList?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(vocList?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sort_by: query.sort_by,
                        order_by: query.order_by,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isVOCListLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={"IMAGE"}
          isOpen={!!linkImage}
          url={linkImage}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default VOCList;
